import { API_REQUEST, VALIDATE_SNAPSHOT } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const validateSnapshot = (snapshotId: number | string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/${snapshotId}/validate`,
    next: VALIDATE_SNAPSHOT,
    method: 'GET',
    authorization: true
  }
});